import { createSelector } from 'reselect'
import getPassportCardInsuranceCoverAmountFromCart from './getPassportCardInsuranceCoverAmountFromCart'

const getPassportCardCheckoutInsuranceCoverAmount = createSelector(
  (state: App.State) => getPassportCardInsuranceCoverAmountFromCart(state),
  (passportCartCoverAmount): number => passportCartCoverAmount || 0,
)

export default getPassportCardCheckoutInsuranceCoverAmount
